/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import Belegart from "../Queries/Belegart";

export default class BelegeUrlsBuilder {
    public static getBelegUrl(belegart: Belegart, belegId: string) {
        return "/mandantBeleg/" + belegart + "/" + belegId;
    }
}